const faqItems = [
  {
    q: '51动漫网真的完全免费吗？',
    a: '是的，51动漫网所有动漫资源均免费在线观看，无需注册登录即可畅享全集。我们致力于为广大动漫爱好者提供一个零门槛的观看平台，让每个人都能自由享受动漫的乐趣。',
  },
  {
    q: '下拉式阅读是什么意思？怎么使用？',
    a: '下拉式阅读是我们为漫画爱好者设计的独特浏览方式。观看漫画时，只需像刷短视频一样上下滑动屏幕，漫画内容就会自动连续加载，无需频繁点击翻页，阅读体验更加流畅自然。',
  },
  {
    q: '新番更新速度快吗？多久更新一次？',
    a: '我们的更新团队每日同步日本、韩国及国内的番剧更新进度。热门连载番剧通常在官方播出后24小时内即可上线，确保你能第一时间追到最新内容，不会错过任何精彩剧集。',
  },
  {
    q: '支持哪些设备观看？有APP吗？',
    a: '51动漫网采用响应式设计，完美适配电脑、平板和手机浏览器。无论你使用什么设备，都能获得流畅的观看体验。移动端页面已进行专项优化，在手机上同样拥有出色的浏览和播放效果。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-600">关于51动漫网，你可能想了解的问题都在这里</p>
        </div>
        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70">
              <h3 className="text-sm md:text-base font-medium text-foreground-950 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center text-xs text-primary-500 mt-0.5">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center text-xs text-accent-700 mt-0.5">A</span>
                <span>{item.a}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}